export default __webpack_public_path__ + "static/media/34.e1d1415e.jpg";